



























































































import ApiClient from '@/common/api'
import BlueButton from '@/views/atoms/BlueButton.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import SelectBox from '@/views/atoms/SelectBox.vue'
import Global from '@/common/global.js'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'
import BackButton from '@/views/atoms/BackButton.vue'
import store from '@/store'
import PopupChangePassowrd from '@/views/template/PopupChangePassowrd.vue'
import TextArea from '@/views/atoms/TextArea.vue'
import PopupComfirmSave from '@/views/template/PopupComfirmSave.vue'
import PopupComfirmEdit from '@/views/template/PopupComfirmEdit.vue'
import PopupComplete from '@/views/template/PopupComplete.vue'

export default
  components: {
    ApiClient
    BlueButton
    TextBox
    SelectBox
    Global
    ErrorLabel
    BackButton
    PopupChangePassowrd
    TextArea
    PopupComfirmSave
    PopupComfirmEdit
    PopupComplete
  }

  data: () ->
    paramsId: false
    showChangePassword: false
    id: ''
    supplySourceList: Global.supplySource()
    defaultSupplySource: store.getters.getAdminData.supply_source
    defaultDepartment: '1'
    isShowPopup: {}
    departmentList: Global.departmentList()
    complete: ''

  created: () ->
    store.dispatch('initPostParam')
    store.dispatch('setErrors', [])
    if @.$route.params.id > 0
      @paramsId = true
      api = new ApiClient()
      data = await api.get('/admin/user/detail/' + @.$route.params.id)
      @defaultSupplySource = data.detail.supply_source
      @defaultDepartment = data.detail.department
      store.dispatch('setDetailParam', data)

  methods: {
    save_click: () ->
      postParam = store.getters.getPostParam
      param = 
        laboratory_name: postParam.laboratory_name
        department: postParam.department
        supply_source: postParam.supply_source
        account_name: postParam.account_name
        extension_number: postParam.extension_number
        remarks1: postParam.remarks1
        remarks2: postParam.remarks2
        password: postParam.password
        contactAddress: [{
          name: postParam.name1
          mailaddress: postParam.mailaddress1
          extension_number: postParam.extension_number1
        },
        {
          name: postParam.name2
          mailaddress: postParam.mailaddress2
          extension_number: postParam.extension_number2
        }]
      api = new ApiClient()
      data = await api.post('/admin/user/save', param)
      if data.errors.length == 0
        @complete = '登録'
        @showPopup('complete')
      @closePopup('save')
    back: () ->
      @$router.push '/admin/user'
    edit_click: () ->
      postParam = store.getters.getPostParam
      param = 
        id: @.$route.params.id
        laboratory_name: postParam.laboratory_name
        department: postParam.department
        supply_source: postParam.supply_source
        account_name: postParam.account_name
        extension_number: postParam.extension_number
        remarks1: postParam.remarks1
        remarks2: postParam.remarks2
        contactAddress: [{
          name: postParam.name1
          mailaddress: postParam.mailaddress1
          extension_number: postParam.extension_number1
        },
        {
          name: postParam.name2
          mailaddress: postParam.mailaddress2
          extension_number: postParam.extension_number2
        }]
      api = new ApiClient()
      data = await api.post('/admin/user/save', param)
      if data.errors.length == 0
        @complete = '変更'
        @showPopup('complete')
      @closePopup('edit')
    close: () ->
      @showChangePassword = false
    passShowPopup: (id) ->
      @id = @.$route.params.id
      @showChangePassword = true
    showPopup: (property) ->
      @$set(@isShowPopup, property, true)
    closePopup: (property) ->
      @$set(@isShowPopup, property, false)
    change: (v) ->
      @defaultSupplySource = v.val
    moveTopPage: () ->
      @$router.push '/admin/user'
    save_pass: () ->
      param =
        id: @.$route.params.id
        password: store.getters.getPostParam.password
      api = new ApiClient()
      data = await api.post('/admin/user/change_password', param)
      if data.errors.length == 0
        @close()
  }
